import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetAppAdminsResponseBody,
  IApiInviteAppAdminRequestBody,
  IApiInviteAppAdminResponseBody,
  IApiRemoveAppAdminRequestBody,
} from './AppAdminsApi.types';

export class AppAdminsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(appId: string): Promise<IApiGetAppAdminsResponseBody> {
    const request: IApiJsonRequest = {
      path: `/apps/${appId}/admins`,
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetAppAdminsResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  /**
   * @param appId - the id of the app
   * @param body - the api expects a firstname and lastname that will be used to create
   * a new account, if the provided email is not associated to any registered account
   */
  public async invite(
    appId: string,
    body: IApiInviteAppAdminRequestBody,
  ): Promise<IApiInviteAppAdminResponseBody> {
    const request: IApiJsonRequest = {
      path: `/apps/${appId}/admins`,
      method: 'post',
      body,
    };

    const response =
      await this.client.fetchJson<IApiInviteAppAdminResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async delete(
    appId: string,
    body: IApiRemoveAppAdminRequestBody,
  ): Promise<boolean> {
    const request: IApiJsonRequest = {
      path: `/apps/${appId}/admins`,
      method: 'delete',
      body,
    };

    const response = await this.client.fetchJson<boolean>(request, { appId });

    return response.body;
  }
}
